export default {
  data() {
    return {
      columns: [
        {
          title: '序号',
          width: 60,
          customRender: (text, record, index) =>
            (this.pageData.current - 1) * this.pageData.pageSize + (index + 1),
        },
        {
          title: '调整后账期',
          dataIndex: 'targetTerm',
          scopedSlots: { customRender: 'targetTerm' },
        },
        {
          title: '调整后额度',
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
        },
        {
          title: '调减后到期日',
          dataIndex: 'indate',
        },
        {
          title: '调整后限额条件',
          dataIndex: 'limitConditionAmount',
          scopedSlots: { customRender: 'limitConditionAmount' },
        },
        {
          title: '调整时间',
          dataIndex: 'createTime',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 120,
          ellipsis: true,
          scopedSlots: { customRender: 'remark' },
        },

        {
          title: '操作人',
          dataIndex: 'operator',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
